"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Checkbox = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = require("styled-components");
var _lodash = _interopRequireDefault(require("lodash.noop"));
var _oxygenConfig = require("@8x8/oxygen-config");
var _oxygenSwitchBase = _interopRequireDefault(require("@8x8/oxygen-switch-base"));
var _CheckboxIcon = _interopRequireDefault(require("./CheckboxIcon"));
var _styled = require("../styled");
var _excluded = ["theme", "testId", "id", "label", "value", "name", "infoBoxText", "isChecked", "isIndeterminate", "isDisabled", "showLabelTooltipOnOverflow", "onChange", "onBlur", "onFocus"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Checkbox = function Checkbox(_ref) {
  var theme = _ref.theme,
    testId = _ref.testId,
    id = _ref.id,
    label = _ref.label,
    value = _ref.value,
    name = _ref.name,
    infoBoxText = _ref.infoBoxText,
    isChecked = _ref.isChecked,
    isIndeterminate = _ref.isIndeterminate,
    isDisabled = _ref.isDisabled,
    showLabelTooltipOnOverflow = _ref.showLabelTooltipOnOverflow,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    onFocus = _ref.onFocus,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHovered = _useState2[0],
    setIsHovered = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFocused = _useState4[0],
    setIsFocused = _useState4[1];
  var handleOnBlur = function handleOnBlur() {
    onBlur();
    setIsFocused(false);
  };
  var handleOnFocus = function handleOnFocus() {
    onFocus();
    setIsFocused(true);
  };
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_oxygenSwitchBase["default"], _extends({
    testId: testId,
    theme: theme,
    id: id,
    icon: /*#__PURE__*/_react["default"].createElement(_styled.CheckboxIconWrapper, {
      hasLabel: !!label,
      isChecked: isChecked,
      isDisabled: isDisabled,
      isFocused: isFocused,
      isHovered: isHovered,
      isIndeterminate: isIndeterminate
    }, /*#__PURE__*/_react["default"].createElement(_CheckboxIcon["default"], {
      theme: theme,
      color: "currentColor",
      isChecked: isChecked,
      isIndeterminate: isIndeterminate
    })),
    label: label,
    value: value,
    name: name,
    infoBoxText: infoBoxText,
    isChecked: isChecked,
    isDisabled: isDisabled,
    showLabelTooltipOnOverflow: showLabelTooltipOnOverflow,
    onChange: onChange,
    onMouseEnter: function onMouseEnter() {
      return setIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovered(false);
    },
    onBlur: handleOnBlur,
    onFocus: handleOnFocus
  }, rest)));
};
exports.Checkbox = Checkbox;
Checkbox.propTypes = {
  /**
   * Checkbox theme
   */
  theme: _propTypes["default"].object,
  /**
   * Checkbox test id
   */
  testId: _propTypes["default"].string,
  /**
   * Value for `id` input attribute and `htmlFor` label attribute
   * @default: autogenerated
   */
  id: _propTypes["default"].string,
  /**
   * Specifies the label content for the checkbox input (text or custom component)
   */
  label: _propTypes["default"].node,
  /**
   * Checkbox input value
   */
  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].bool, _propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired
  })]),
  /**
   * Specifies the name prop for the checkbox input
   */
  name: _propTypes["default"].string,
  /**
   * Shows info icon and renders text inside Tooltip
   */
  infoBoxText: _propTypes["default"].node,
  /**
   * Specifies if the checkbox is checked
   */
  isChecked: _propTypes["default"].bool,
  /**
   * Specifies if the checkbox has indeterminate state
   */
  isIndeterminate: _propTypes["default"].bool,
  /**
   * Specifies if the checkbox is disabled
   */
  isDisabled: _propTypes["default"].bool,
  /**
   * Whether to show tooltip when the Label content overflows label.
   * Note: The Label content is the input, checkbox icon and the text
   */
  showLabelTooltipOnOverflow: _propTypes["default"].bool,
  /**
   * Callback for the checkbox input
   */
  onChange: _propTypes["default"].func,
  /**
   *  Synthetic event
   */
  onBlur: _propTypes["default"].func,
  /**
   *  Synthetic event
   */
  onFocus: _propTypes["default"].func
};
Checkbox.defaultProps = {
  theme: {},
  testId: 'CHECKBOX',
  id: undefined,
  label: null,
  value: '',
  name: undefined,
  infoBoxText: undefined,
  isChecked: false,
  isIndeterminate: false,
  isDisabled: false,
  showLabelTooltipOnOverflow: true,
  onBlur: _lodash["default"],
  onChange: _lodash["default"],
  onFocus: _lodash["default"]
};
var _default = (0, _oxygenConfig.withTheme)(Checkbox, 'checkbox');
exports["default"] = _default;